import React, {useEffect , useState} from 'react';
import {useLocation} from 'react-router-dom';
import {useSelector} from 'react-redux'
import LinearProgress from '@mui/material/LinearProgress';
import CircularProgress from '@mui/material/CircularProgress';

import '../assets/css/pre-loader.css';



const Preloader = () => {
    const [ singleLoader, setSingleLoader ] = useState(false);
    const [ fullPageLoader, setFullPageLoader] = useState(true);

    const {pathname} = useLocation();
    const { progressing } = useSelector(e => e.progessingRequest);

    
    useEffect(()=>{
        setSingleLoader(true);

        setTimeout(()=> {
            setSingleLoader(false);
        }, 500);

    },[pathname]);


    useEffect(()=>{
        setTimeout(()=> {
            setSingleLoader(progressing);
        }, 500);
    },[progressing]);


    window.onload = () => {
        setFullPageLoader(false);
        document.getElementsByTagName('body')[0].setAttribute('app', 'loaded');
    };

    return (
        <>
            {
                singleLoader &&
                <div className='pre-loader'>
                    <LinearProgress/>
                </div>
            }

            {
                fullPageLoader &&
                <div className='full-page-preloader'>
                    <CircularProgress/>
                </div>
            }
        </>
    )
}

export default Preloader;
